import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/font/PretendardVariable.woff2\",\"display\":\"swap\",\"weight\":\"45 920\",\"variable\":\"--font-pretendard\"}],\"variableName\":\"pretendard\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/app/_components/DatadogRumInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/app/_components/FirstTouchInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/app/_components/MetaPixelInit.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/web/web/src/styles/globals.css");
